/**** mgt.Driver */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Driver',
  title: "Сотрудники",
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    depots: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
    },
    departments: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Department',
      index: 'td_id',
      fields: ['td_name'],
      format: (elem: any) => elem['td_name'],
    }
  },
  fields: [
    {
      name: 'driver_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px'
    },
    {
      name: 'last_name',
      title: 'Фамилия',
      type: 'text',
      required: true
    },
    {
      name: 'first_name',
      title: 'Имя',
      type: 'text',
      required: true
    },
    {
      name: 'middle_name',
      title: 'Отчество',
      type: 'text',
      required: false
    },
    {
      name: 'depot_id',
      title: 'Филиал',
      type: 'number',
      required: false,
      connection: 'depots',
    },
    {
      name: 'table_number',
      title: 'Табельный номер',
      type: 'number',
      required: true
    },
    {
      name: 'td_id',
      title: 'Территориальный отдел',
      type: 'number',
      required: false,
      connection: 'departments'
    },
    {
      name: 'convoy_chief_full_name',
      title: 'ФИО руководителя колонны',
      type: 'text',
      required: false,
    },
    {
      name: 'convoy_chief_number',
      title: 'Телефон руководителя колонны',
      type: 'text',
      required: false,
    },
    {
      name: 'park_chief_full_name',
      title: 'ФИО руководителя парка',
      type: 'text',
      required: false,
    },
    {
      name: 'park_chief_number',
      title: 'Телефон руководителя парка',
      type: 'text',
      required: false,
    },
    {
      name: 'start_date',
      title: 'Дата начала работы',
      type: 'date',
      required: false,
    },
    {
      name: 'end_date',
      title: 'Дата окончания работы',
      type: 'date',
      required: false,
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px'
    }
  ],
  newTemplate: {
    driver_id: null,
    last_name: '',
    first_name: '',
    middle_name: '',
    depot_id: '',
    table_number: '',
    do_not_update: true,
    convoy_chief_full_name: '',
    convoy_chief_number: '',
    park_chief_full_name: '',
    park_chief_number: '',
  },
  makeIdOnInsert: true,
  updateField: 'update_date',
  defaultSort: {
    field: 'driver_id',
    direction: 'desc'
  },
 import: {
    header: [
      {
        title: 'worker_id',
        field: 'driver_id',
      },
      {
        title: 'surname',
        field: 'last_name',
      },
      {
        title: 'name',
        field: 'first_name',
      },
      {
        title: 'middle_name',
        field: 'middle_name',
      },
      {
        title: 'employee_number',
        field: 'table_number',
      },
      {
        title: 'depot_id',
        field: 'depot_id',
      },
      {
        title: 'td_id',
        field: 'td_id',
      },
      {
        title: 'convoy_chief_full_name',
        field: 'convoy_chief_full_name',
      },
      {
        title: 'convoy_chief_number',
        field: 'convoy_chief_number',
      },
      {
        title: 'park_chief_full_name',
        field: 'park_chief_full_name',
      },
      {
        title: 'park_chief_number',
        field: 'park_chief_number',
      },
      {
        title: 'start_date',
        field: 'start_date',
      },
      {
        title: 'end_date',
        field: 'end_date',
      }
    ],
    example: `1;Иванов;Иван;Иванович;111111;1;1;1970-01-01;2030-01-01`,
 },
  export: {
    connections: {
      agency: {
        index: 'depot_id',
        customsql:
          `SELECT t1.title, t2.depot_id
           FROM mgt."Agency" t1
           INNER JOIN mgt."Depot" t2 ON t1.agency_id = t2.agency_id`,
      },
    },
    fields:      [
      {
        name:  'last_name',
        title: 'Фамилия',
      },
      {
        name:  'first_name',
        title: 'Имя',
      },
      {
        name:  'middle_name',
        title: 'Отчество',
      },
      {
        name:  'depot_id',
        title: 'Филиал',
      },
      {
        name:            'agency_title',
        title:           'Предприятие перевозчика',
        connection:      'agency',
        connectionField: 'depot_id',
      },
      {
        name:  'table_number',
        title: 'Табельный номер',
      },
      {
        name:  'td_id',
        title: 'Территориальный отдел',
      },
      {
        name:  'convoy_chief_full_name',
        title: 'ФИО руководителя колонны',
      },
      {
        name:  'convoy_chief_number',
        title: 'Телефон руководителя колонны',
      },
      {
        name:  'park_chief_full_name',
        title: 'ФИО руководителя парка',
      },
      {
        name:  'park_chief_number',
        title: 'Телефон руководителя парка',
      },
      {
        name:  'start_date',
        title: 'Дата начала работы',
      },
      {
        name:  'end_date',
        title: 'Дата окончания работы',
      },
    ],
  },
};

export default config;
